import apiClient from '@shared/api'
import dcmApiClient from '@/shared/api/dcm/dcmApiClient'
import { installRequestInterceptor } from '@shared/utils/interceptors/requestInterceptor'
import { installResponseInterceptor } from '@internal/interceptors/responseInterceptor'
import { ERouterList } from '@internal/router/constants/router-list'
import type { IRouteContext } from '@shared/types/route-context'
import authorization from '@shared/utils/authorization'
import type { CognitoUserSession } from 'amazon-cognito-identity-js'
import { saveLogoutRoute } from '@shared/utils/router-logout-saver'

import type { EUserRole } from '@shared/api/user-management/resources/user/constants/user-roles'

export const auth = async ({ next, to }: IRouteContext, middlewareRoleList?: EUserRole[]) => {
  const session: CognitoUserSession | null = await authorization.loadPersisted()
  const customToken = localStorage.getItem('customToken') || null
  const sessionToken: string | null = session ? session.getIdToken().getJwtToken() : customToken

  if (session === null) {
    saveLogoutRoute({
      user: authorization.lastAuthUser,
    })
  }

  if (!sessionToken) {
    return next({
      name: ERouterList.LOGIN,
      query: {
        ...to.query,
      },
    })
  }

  installRequestInterceptor({
    apiClient,
    sessionToken,
  })
  installResponseInterceptor({
    apiClient,
  })

  installRequestInterceptor({
    apiClient: dcmApiClient,
    sessionToken,
  })
  installResponseInterceptor({
    apiClient: dcmApiClient,
  })

  if (authorization.hasAccess(middlewareRoleList)) {
    return next()
  }

  if (to.meta.redirectTo) {
    return next({
      name: to.meta.redirectTo as string,
      query: {
        ...to.query,
      },
    })
  }

  return next({
    name: ERouterList.NOT_FOUND,
    query: {
      ...to.query,
    },
  })
}
